module.exports = __webpack_public_path__ + "static/media/celek1.7641d946.jpg";